module.exports = __webpack_public_path__ + "static/scale-model-of-pomona-california-5960577aaa55e097160fba738f65c450.png";